import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./shared/assets/css/main.css";
import "antd/dist/antd.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";


ReactDOM.render(<App />, document.getElementById("root"));
reportWebVitals();
